export default "__VITE_ASSET__DPH7wzDY__"